import { z } from 'zod';

export const DdiInvoiceFormSchema = z.object({
  invoiceId: z.string().optional(),
  clientName: z.string().optional(),
  caseName: z.string().optional(),
  toServe: z.string().optional(),
  attorney: z.string().optional(),
  contact: z.string().optional(),
  billingDate: z.date().optional(),
  amount: z.string().optional(),
  billingItem: z.string().nullish(),
  billingItemSearch: z.any().nullish(),
  updatedAmount: z.preprocess(
    (val) => {
      if (val === '' || val === null || val === undefined) return undefined;
      const num = Number(val);
      return Number.isNaN(num) ? undefined : num;
    },
    z
      .number({
        invalid_type_error: 'Amount must be a number',
      })
      .max(Number.MAX_SAFE_INTEGER, { message: 'Amount exceeds maximum allowed value' })
      .optional()
  ),
  status: z.enum(['DRAFT', 'REVIEWED', 'CONFIRMED', 'PAID']).nullish(),
});

export type DdiInvoiceFormSchemaType = z.infer<typeof DdiInvoiceFormSchema>;
